// Version : 0.0.1
// Author : Vignesh

import { docodeHexResponse } from '../../../_common/common.utils';
import TrailBalanceTypes from './trailBalance.types';

const INITIAL_STATE = {
	TrailBalanceDetailsResponse: null,
	TrailBalanceDetailsArr: [],
	ShowPDF: false,
};
const TrailBalanceReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET PROFIT AND LOSS START *********************** */
		case TrailBalanceTypes.GET_TRAIL_BALANCE_SUCCESS:
			return {
				...state,
				TrailBalanceDetailsResponse: action.payload,
				TrailBalanceDetailsArr: docodeHexResponse(action.payload, 'TrailBalanceKey'),
				ShowPDF: true,
			};

		case TrailBalanceTypes.GET_TRAIL_BALANCE_FAILURE:
			return {
				...state,
				TrailBalanceDetailsResponse: action.payload,
				TrailBalanceDetailsArr: [],
			};

		case TrailBalanceTypes.GET_TRAIL_BALANCE_RESPONSE_CHANGED:
			return { ...state, TrailBalanceDetailsResponse: null };
		/** ***************** GET PROFIT AND LOSS END *********************** */
		default:
			return state;
	}
};

export default TrailBalanceReducer;
